export default __webpack_public_path__ + "static/media/5.93713adf.webp";